(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["products"]) return;
  try {
    
  /* Mobile LOAD MORE: fetches the next page of this section and appends its
     cards to the grid in place. Desktop uses the theme's <pagination-nav>. */
  if (!customElements.get('load-more-products')) {
    customElements.define(
      'load-more-products',
      class LoadMoreProducts extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-load-more-button]');
          if (!this.button) return;
          this.button.addEventListener('click', this.handleClick.bind(this));
        }

        async handleClick() {
          const nextUrl = this.dataset.nextUrl;
          if (!nextUrl || this.loading) return;

          this.loading = true;
          this.button.classList.add('loading');
          this.button.disabled = true;

          try {
            const url = new URL(nextUrl, window.location.origin);
            url.searchParams.set('section_id', this.dataset.sectionId);

            const response = await fetch(url.toString());
            if (!response.ok) throw new Error('Request failed: ' + response.status);

            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

            const incomingGrid = doc.querySelector('.products');
            const currentGrid = document.querySelector('#ProductList .products');
            if (incomingGrid && currentGrid) {
              currentGrid.append(...incomingGrid.children);
            }

            /* Advance to the page after the one just appended, or retire the
               button when that was the last page. */
            const incomingLoadMore = doc.querySelector('load-more-products');
            if (incomingLoadMore && incomingLoadMore.dataset.nextUrl) {
              this.dataset.nextUrl = incomingLoadMore.dataset.nextUrl;
            } else {
              this.hidden = true;
            }
          } catch (error) {
            console.error('Load more failed', error);
          } finally {
            this.loading = false;
            this.button.classList.remove('loading');
            this.button.disabled = false;
          }
        }
      }
    );
  }

  /* SEO copy read more / read less — ported from the retired
     seo-description section, which this block replaces. */
  (function () {
    function initProductsSeo(root) {
      const container = (root || document).querySelector('[data-products-seo]');
      if (!container || container.dataset.seoBound === 'true') return;

      const content = container.querySelector('[data-expandable-content]');
      const button = container.querySelector('[data-toggle-btn]');
      if (!content || !button) return;

      container.dataset.seoBound = 'true';

      function checkOverflow() {
        if (content.scrollHeight > content.clientHeight) {
          button.style.display = 'inline-flex';
        } else if (!content.classList.contains('expanded')) {
          button.style.display = 'none';
        }
      }

      button.addEventListener('click', function () {
        const isExpanded = content.classList.toggle('expanded');
        button.classList.toggle('expanded', isExpanded);
        button.setAttribute('aria-expanded', String(isExpanded));
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(checkOverflow);
      } else {
        setTimeout(checkOverflow, 100);
      }
      window.addEventListener('resize', checkOverflow);
    }

    initProductsSeo(document);
    document.addEventListener('section:rerendered', function () {
      initProductsSeo(document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('footer-nav-group')) {
    customElements.define(
      'footer-nav-group',
      class FooterNavGroup extends HTMLElement {
        connectedCallback() {
          if (this._initialized) return;

          this._trigger = this.querySelector('[data-footer-nav-trigger]');
          this._panel = this.querySelector('[data-footer-nav-panel]');
          if (!this._trigger || !this._panel) return;

          this._panel.id = this._panel.id || 'footer-nav-panel-' + Math.random().toString(36).slice(2, 9);

          this._onClick = this._toggle.bind(this);
          this._onKeydown = (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            this._toggle();
          };

          this._query = window.matchMedia('(width < 64rem)');
          this._onQueryChange = this._sync.bind(this);
          this._query.addEventListener('change', this._onQueryChange);
          this._sync();

          this._initialized = true;
        }

        disconnectedCallback() {
          if (this._query) this._query.removeEventListener('change', this._onQueryChange);
          this._unbind();
        }

        _sync() {
          if (this._query.matches) {
            this._bind();
          } else {
            this._unbind();
          }
        }

        _bind() {
          if (this._bound) return;
          this._trigger.addEventListener('click', this._onClick);
          this._trigger.addEventListener('keydown', this._onKeydown);
          this._trigger.setAttribute('role', 'button');
          this._trigger.setAttribute('tabindex', '0');
          this._trigger.setAttribute('aria-controls', this._panel.id);
          this._trigger.setAttribute('aria-expanded', this.getAttribute('data-state') === 'open' ? 'true' : 'false');
          this._bound = true;
        }

        _unbind() {
          if (!this._bound) return;
          this._trigger.removeEventListener('click', this._onClick);
          this._trigger.removeEventListener('keydown', this._onKeydown);
          this._trigger.removeAttribute('role');
          this._trigger.removeAttribute('tabindex');
          this._trigger.removeAttribute('aria-controls');
          this._trigger.removeAttribute('aria-expanded');
          this._bound = false;
        }

        _toggle() {
          const open = this.getAttribute('data-state') === 'open';
          this.setAttribute('data-state', open ? 'closed' : 'open');
          this._trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
